import React from "react";
import { Box, Button, Grid } from "@mui/material";
import PropType from "prop-types";
import { parseHtml } from "../../utils/utils";
import { useMuiScreenSizes } from "../../hooks/useMuiScreenSizes";
import AwardCard from "../cards/slide-up-cards/award-card";

AwardsSection.propTypes = {
    awardsPageData: PropType.object.isRequired,
    awards: PropType.array.isRequired
};

function AwardsSection({ awardsPageData, awards }) {
    const { isScreenXLarge } = useMuiScreenSizes();

    return (
        <div className="py-5">
            <div
                style={{
                    position: "relative",
                    height: "auto",
                    padding: 10
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        transform: "scaleX(-1)",
                        background: `
                            radial-gradient(circle at bottom left, #2e5881, transparent 80%),
                            radial-gradient(circle at bottom right, #a0b5cc, transparent 70%),
                            radial-gradient(circle at top center, #d0e2ea, transparent 60%),
                            radial-gradient(circle at bottom center, #003366, transparent 90%),
                            radial-gradient(circle at top left, #80a2b6, transparent 70%),
                            radial-gradient(circle at top right, #ffffff, transparent 80%)
                        `,
                        backgroundAttachment: "fixed",
                        backgroundPosition: isScreenXLarge ? "top right" : "center",
                        backgroundSize: "cover",
                        zIndex: -99
                    }}
                />
                <div className="container py-5">
                    <Grid container spacing={10} justifyContent="space-between">
                        <Grid item xs={12} lg={4} xl={5} marginBottom={3}>
                            <h2 style={{ marginBottom: 30 }}>Awards</h2>
                            <div className="mb-4">
                                <img
                                    src={awardsPageData.contentImageUrl}
                                    alt="NACo"
                                    style={{
                                        width: "50%",
                                        height: "50%",
                                        objectFit: "cover"
                                    }}
                                />
                            </div>
                            <Box sx={{ fontSize: { xs: "medium", sm: "large" } }}>
                                {parseHtml(awardsPageData.content)}
                            </Box>
                        </Grid>
                        <Grid item xs={12} lg={8} xl={7}>
                            <Grid
                                container
                                spacing={3}
                                justifyContent={isScreenXLarge ? "left" : "right"}
                                alignItems="start"
                            >
                                {awards.map((award, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <AwardCard
                                            imageUrl={award.imageUrl}
                                            title={award.title}
                                            subtitle={award.secondaryDescription}
                                            content={parseHtml(award.description)}
                                            customComponent={
                                                award.buttonLink && (
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        sx={{
                                                            width: "fit-content",
                                                            padding: "0 8px",
                                                            marginTop: "4px",
                                                            borderRadius: "15px",
                                                            textTransform: "none"
                                                        }}
                                                        onClick={() => {
                                                            window.open(award.buttonLink, "_blank");
                                                        }}
                                                    >
                                                        {award.buttonText}
                                                    </Button>
                                                )
                                            }
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
}

export default AwardsSection;
